<!-- Footer Start -->
<div
  class="container-fluid bg-dark text-white-50 footer pt-5 mt-5 wow fadeIn"
  data-wow-delay="0.1s"
>
  <div class="container py-5">
    <div class="row g-5">
      <!-- Get In Touch Start-->
      <div class="col-lg-5 col-md-6">
        <h3 class="text-white mb-4">{{ "get_in_touch" | translate }}</h3>
        <p class="mb-2">
          <i class="fa fa-map-marker-alt me-3"></i>
          {{ getInTouch.address[language] }}
        </p>
        <p class="mb-2">
          <i class="fa fa-phone-alt me-3"></i> {{ getInTouch.phone }}
        </p>
        <p class="mb-2">
          <i class="fa fa-envelope me-3"></i> {{ getInTouch.mail }}
        </p>
        <div class="d-flex pt-2">
          <a
            *ngIf="isNational"
            class="btn btn-outline-light btn-social"
            href="https://www.facebook.com/Ecole.Girard.Alexandria"
            ><i class="fab fa-facebook-f"></i
          ></a>
          <a
            *ngIf="!isNational"
            class="btn btn-outline-light btn-social"
            href="https://www.facebook.com/p/Ecole-Girard-Section-Fran%C3%A7aise-Internationale-BAC-100065469009847/"
            ><i class="fab fa-facebook-f"></i
          ></a>
          <!-- <a
            class="btn btn-outline-light btn-social"
            href="https://x.com/EcoleGirard"
            ><i class="fab fa-twitter"></i
          ></a> -->
          <a
            class="btn btn-outline-light btn-social"
            href="https://www.youtube.com/user/EcoleGirard"
            ><i class="fab fa-youtube"></i
          ></a>
          <a class="btn btn-outline-light btn-social" href=""
            ><i class="fab fa-linkedin-in"></i
          ></a>
          <a
            *ngIf="isNational"
            class="btn btn-outline-light btn-social"
            href="https://www.instagram.com/explore/locations/1019866531/ecole-girard---alexandrie/"
            ><i class="fab fa-instagram"></i
          ></a>
          <a
            *ngIf="!isNational"
            class="btn btn-outline-light btn-social"
            href="https://www.instagram.com/girar.sec.francaise2022/"
            ><i class="fab fa-instagram"></i
          ></a>
        </div>
      </div>
      <!-- Get In Touch End-->

      <!-- Quick Links Start -->
      <div class="col-lg-4 col-md-6">
        <h3 class="text-white mb-4">{{ "quick_links" | translate }}</h3>
        <div class="link">
          <a
            *ngFor="let linkObj of footerLinks"
            class="btn btn-link text-white-50"
            href="{{ linkObj.href }}"
            >{{ linkObj.name | translate }}
          </a>
        </div>
      </div>
      <!-- Quick Links End -->

      <!-- Newsletter Start -->
      <div class="col-lg-3 col-md-6">
        <h3 class="text-white mb-4" style="font-size: xx-large">
          {{ "newsletter" | translate }}
        </h3>
        <p>{{ "newsletter_text" | translate }}</p>
        <div class="position-relative mx-auto" style="max-width: 400px">
          <input
            class="form-control bg-transparent w-100 py-3 ps-4 pe-5"
            type="email"
            placeholder="{{ 'your_email' | translate }}"
            (change)="onSubmitEmail($event)"
          />
          <button
            type="button"
            class="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
            [disabled]="!isValidEmail(subscribedEmail)"
            (click)="emailSubscribe()"
          >
            {{ "sign_up" | translate }}
          </button>
        </div>
        <!-- Vistors Start -->
        <br />
        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: baseline;
            justify-content: flex-start;
            flex-wrap: wrap;
          "
        >
          <h3 class="text-white mb-4" style="font-size: x-large">
            {{ "visitors" | translate }}
          </h3>
          <p style="margin: 2%; font-size: large">
            {{ visitsCount }}
          </p>
        </div>
        <!-- Vistors End -->
      </div>
    </div>
    <!-- Newsletter End -->
  </div>
  <!-- Rights Start -->
  <div class="container">
    <div class="copyright">
      <div class="row">
        <span class="col-md-10 text-md-start mb-3 mb-md-0">
          &copy;
          <a class="border-bottom" href="/home"
            >{{ "girard" | translate }} 2025</a
          >, {{ "all_rights_reserved" | translate }}
          {{ "designed_by" | translate }}
          <a
            class="border-bottom"
            href="https://www.linkedin.com/in/adel-meleka/"
            >{{ "adel_atef" | translate }}</a
          >
          {{ "and" | translate }}
          <a
            class="border-bottom"
            href="https://www.linkedin.com/in/sandra-sherif-7b3445158/"
            >{{ "sandra_sherif" | translate }}</a
          >.
        </span>
      </div>
    </div>
  </div>
  <!-- Rights End -->
</div>
<!-- Footer End -->
